import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { UserAuthService } from '../services/user-auth.service';

@Injectable({
  providedIn: 'root'
})
export class InvalidUrlGuard implements CanActivate {
  constructor(private readonly router: Router, private readonly userAuthService: UserAuthService) {}

  canActivate(_: never, state: RouterStateSnapshot): boolean | UrlTree {
    const hasAccessToken = !!this.userAuthService.getAccessToken();
    const hasLoginFlag = !!localStorage.getItem('isLoginSuccess');
    const requestedUrl = state.url || '';
    const sanitizedPath = requestedUrl.split('?')[0].split('#')[0].toLowerCase();
    const lastPublicRoute = sessionStorage.getItem('lastPublicRoute');
    const hasLastHlRegistrationRoute = !!lastPublicRoute && lastPublicRoute.toLowerCase().startsWith('/hl-registration');

    if (!hasAccessToken || !hasLoginFlag) {
      if (sanitizedPath.startsWith('/hl-registration')) {
        return this.router.parseUrl('/hl-registration');
      }

      if (hasLastHlRegistrationRoute) {
        return this.router.parseUrl(lastPublicRoute);
      }

      return this.router.parseUrl('/register');
    }

    const lastValidUrl = sessionStorage.getItem('lastValidRoute');
    if (lastValidUrl && lastValidUrl.startsWith('/portal') && lastValidUrl !== state.url) {
      return this.router.parseUrl(lastValidUrl);
    }

    return this.router.parseUrl('/portal/home');
  }
}
